import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import OrgariumAcc from "../OrgariumAcc";

export default function FaqList({ data }) {
  const [active, setActive] = useState("collapse0");

  const toggle = (val) => {
    if (val === active) {
      setActive("");
    } else {
      setActive(val);
    }
  };

  return (
    <section className="faq-section pt-70 pb-110">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-10">
            <div className="section-title text-center mb-70 wow fadeInUp">
              <span className="sub-title">{data?.subheading}</span>
              <h2>{data?.heading}</h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="faq-one_content-box wow fadeInDown">
              <Accordion
                defaultActiveKey="collapse0"
                className="accordion"
                id="accordionOne"
              >
                {data?.list?.map((faq, i) => (
                  <OrgariumAcc
                    title={faq.question}
                    answer={faq.answer}
                    key={i}
                    event={`collapse${i}`}
                    onClick={() => toggle(`collapse${i}`)}
                    active={active}
                  />
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
